<div *ngIf="isLoading" class="ds-chart-card">
  <div class="ds-card-title"></div>
  <div class="ds-chart-area">
    <div class="ds-chart-bars">
      <div class="ds-bar" style="height: 55%"></div>
      <div class="ds-bar" style="height: 70%"></div>
      <div class="ds-bar" style="height: 40%"></div>
      <div class="ds-bar" style="height: 85%"></div>
      <div class="ds-bar" style="height: 60%"></div>
      <div class="ds-bar" style="height: 75%"></div>
      <div class="ds-bar" style="height: 50%"></div>
      <div class="ds-bar" style="height: 90%"></div>
      <div class="ds-bar" style="height: 45%"></div>
      <div class="ds-bar" style="height: 65%"></div>
      <div class="ds-bar" style="height: 35%"></div>
      <div class="ds-bar" style="height: 80%"></div>
    </div>
  </div>
</div>

<kodit-card-container *ngIf="!isLoading" [showDivider]="false">
  <ng-container card-title>Promet</ng-container>

  <ng-container card-body>
    <p-chart type="bar" [data]="chartData" [options]="chartOptions"></p-chart>
  </ng-container>
</kodit-card-container>
